import FullCalculator from 'components/FullCalculator/FullCalculator';
import { CalculatorOptions } from 'types/calculator/CalculatorOptions';
import { CalculatorKind } from 'types/learningMaterials';

type CalculatorLessonProps = {
  calculatorKind: CalculatorKind;
  calculatorOptions: CalculatorOptions;
};

export const CalculatorLesson = ({ calculatorKind, calculatorOptions }: CalculatorLessonProps) => {
  return (
    <div className='calculator-content lesson-content'>
      <FullCalculator initialCalculatorOptions={calculatorOptions} calcKind={calculatorKind} htmlColor={'#467d80'} />
    </div>
  );
};
